import React from 'react';
import NaptarBejegyzesekContent from './NaptarBejegyzesekContent';
import { szabadsagService } from '../services/szabadsagService';
import { Permissions } from '../services/permissionService';

const SzabadsagokContent: React.FC = () => {
  return (
    <NaptarBejegyzesekContent
      title="Szabadságok"
      selectedMenu="szabadsagok"
      service={szabadsagService}
      createPermission={Permissions.CreateLeaves}
      editPermission={Permissions.EditLeaves}
      deletePermission={Permissions.DeleteLeaves}
      addDialogTitle="Új szabadság bejegyzés"
      defaultStartTime="08:00"
      defaultEndTime="17:00"
    />
  );
};

export default SzabadsagokContent;
